module.exports = __webpack_public_path__ + "img/licor1a.f44e5c26.png";